import React, { useState } from 'react'
import { Card } from 'components/card'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import './styles.scss'

export const Chapter = ({ category, charts, comment }) => {
  return (
    <>
      <div
        className='ui vertical segment'
        style={{ marginBottom: '0', paddingBottom: '0' }}
      >
        <div className='ui text container'>
          <h3 className='ui center aligned icon medium header'>
            <div className='dividerLine' />
            {/* <i style={{boxShadow: "none"}} className="circular globe icon" /> */}
            {/* <img
            style={{
              display: "block",
              verticalAlign: "middle",
              margin: "auto",
              marginBottom: "1em",
             width: "3em",
            border:"1px"}}
            className='ui large circular image'
            src={require('../../images/flag_russia.png')}
          /> */}
            {category}
            <div className='dividerLine' />
          </h3>
        </div>
        <div className='ui container'>
          <div className='ui two doubling stackable cards'>
            {charts.map(l => (
              <Card
                key={l.title}
                title={l.titel}
                subtitle={l.untertitel}
                link={l.link}
              />
            ))}
          </div>
          <div className='example ta text'>
            <h5>Anmerkungen</h5>
            {comment !== undefined ? (
              <p
                dangerouslySetInnerHTML={{
                  __html: comment.replace(/href/g, "target='_blank' href")
                }}
              />
            ) : null}
          </div>
        </div>

        {/* <div className='ui text container'> */}

        {/* </div> */}
      </div>
    </>
  )
}
